import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import "./WebSolutions.scss";
import PageBanner from "../layouts/PageBanner";
import bannerWeb from "../../assets/about-hero.jpg";

const API = "https://api.ainfotech.com.np";

const WebSolutionDetail = () => {
  const { key } = useParams(); // treat as slug
  const navigate = useNavigate();

  const [item, setItem] = useState(null);
  const [all, setAll] = useState([]);

  // Load current item
  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API}/api/websolutions/${key}`);
        if (res.status === 404) { setItem(null); return; }
        const data = await res.json();
        if (!res.ok) throw new Error(data?.error || "Failed to load item");
        setItem(data);
        window.scrollTo(0, 0);
      } catch (e) {
        console.error(e);
        setItem(null);
      }
    })();
  }, [key]);

  // Load list for sidebar “Other Web Solutions”
  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API}/api/websolutions?status=published&page=1&limit=50`);
        const data = await res.json();
        if (!res.ok) throw new Error(data?.error || "Failed to load list");
        setAll(Array.isArray(data.items) ? data.items : []);
      } catch (e) {
        console.error(e);
        setAll([]);
      }
    })();
  }, []);

  const others = useMemo(
    () => all.filter((x) => x.slug !== key).slice(0, 6),
    [all, key]
  );

  if (!item) {
    return (
      <div className="container py-5">
        <h3 className="mb-2">Item not found</h3>
        <p className="text-muted">This web solution may have been moved or renamed.</p>
        <Link to="/websolutionspage" className="btn btn-outline-secondary">Back to Web Solutions</Link>
      </div>
    );
  }

  const cover = item.cover_image ? `${API}${item.cover_image}` : undefined;

  return (
    <div className="avena-services-page">
      <PageBanner
        title={item.title}
        bg={bannerWeb}
        crumbs={[
          { label: "Home", href: "/" },
          { label: "Web Solutions", href: "/websolutionspage" },
          { label: item.title },
        ]}
      />

      <section className="svc-detail">
        <div className="container">
          <div className="row g-4">
            <div className="col-12 col-lg-8">
              <article className="svc-article">
                <h1 className="svc-detail__title">{item.title}</h1>

                <div
                  className="svc-hero"
                  style={{ backgroundImage: cover ? `url(${cover})` : undefined }}
                  role="img"
                  aria-label={item.title}
                />

                <div className="svc-content">
                  {/* Show excerpt if you like */}
                  

                  {/* Render Jodit HTML */}
                  <div
                    className="svc-rich"
                    dangerouslySetInnerHTML={{ __html: item.content_html || "" }}
                  />

              
                </div>
              </article>
            </div>

            <div className="col-12 col-lg-4">
              <aside className="svc-sidebar">
                <div className="svc-sidecard">
                  <h5 className="svc-sidecard__title">Other Web Solutions</h5>
                  <ul className="svc-side-list">
                    {others.map((o) => {
                      const thumb = o.cover_image ? `${API}${o.cover_image}` : undefined;
                      return (
                        <li key={o.id}>
                          <button
                            type="button"
                            className="svc-side-item"
                            onClick={() => navigate(`/websolutions/${o.slug}`)}
                          >
                            <div
                              className="svc-side-thumb"
                              style={{ backgroundImage: thumb ? `url(${thumb})` : undefined }}
                            />
                            <span className="svc-side-name">{o.title}</span>
                          </button>
                        </li>
                      );
                    })}
                  </ul>
                </div>

                <Link to="/websolutionspage" className="svc-backlink">← Back to Web Solutions</Link>
              </aside>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WebSolutionDetail;
